import React from "react";
import { useSelector } from "react-redux";
import numeral from "numeral";
import ReconciliationDeadlineBlock from "./deadlineCard";
import FilterDeadlines from "./filterDeadlines";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const AddExistingDeadline = props => {

  const {endDateFilter,
    setEndDateFilter,
    startDateFilter,
    setStartDateFilter,
    selectedCounterparts,
    setSelectedCounterparts,
    selectedDeadlines,
    filterDone,
    residueAmount,
    deadlinesPlus,
    setDeadlinesPlus,
    dateError,
    tooManyDeadlines} = props;

  const deadlines = useSelector(state => state.deadlinesAccountant);
  const deadlinesCounterparts = useSelector(state => state.deadlinesAccountant?.deadlinesCounterparts);

  const renderDeadlines = () => {
    let items = [];
    if (deadlines.effectiveOrNot && deadlines.effectiveOrNot.deadlines) {
      // Devo poter scegliere solo tra le scadenze con importo uguale all'importo residuo e che non sono già selezionate per non ripeterle
      let filteredDeadlinesToSelect = deadlines.effectiveOrNot.deadlines.filter(deadline =>
        (numeral(Math.abs(deadline.totalAmount)).format("0,0.00") === numeral(Math.abs(residueAmount)).format("0,0.00")) && selectedDeadlines.indexOf(deadline.id) === -1);
      if (filteredDeadlinesToSelect.length > 0){
        filteredDeadlinesToSelect.forEach((deadline, index) => {
          items.push(<ReconciliationDeadlineBlock
            key={"dbx-popup-addExtistingDeadline-" + index}
            deadline={deadline}
            totalAmount={deadline.totalAmount}
            counterpartName={deadline.counterpart?.description}
            date={deadline.date}
            description={
              deadline.description.details || deadline.description.title
            }
            showDetail={false}
            onClick={value => {
              let tmpSelected = [...deadlinesPlus];
              if (deadlinesPlus.indexOf(value) > -1) {
                tmpSelected.splice(deadlinesPlus.indexOf(value), 1);
              } else {
                tmpSelected.push(value);
              }
              setDeadlinesPlus(tmpSelected);
              // handleSelectedDeadlines(value, deadline);
            }}
            selectedDeadlines={deadlinesPlus}
            canSelect={true}
          />);
        });
        return items;
      } 
      return (<div style={{ marginTop: "40px" }}>
        <div>
          <FontAwesomeIcon
            style={{
              color: "rgb(228, 234, 240)",
              fontSize: "100px",
              cursor: "pointer"
            }}
            icon={["far", "alarm-clock"]}
          />
        </div>
        <div
          style={{
            color: "rgb(0, 80, 117)",
            fontSize: "16px",
            textAlign: "center",
            marginTop: "10px"
          }}
        >
              Nessuna scadenza trovata con importo uguale al residuo
        </div>
      </div>);      
    }
    return undefined;
  };

  let deadlinesCounterpartsArrObj;
  if ( deadlinesCounterparts !== null && deadlinesCounterparts.length > 0 ) {
    deadlinesCounterpartsArrObj = deadlinesCounterparts?.map(counterpart => {
      return {
        description: counterpart
      };
    });
  }

  return (
    <div className="dbx-reconciliation-modal-addExtistingDeadlines-root">
      <div className="dbx-reconciliation-modal-addExtistingDeadlines-title">
        Aggiungi scadenza esistente
      </div>
      {tooManyDeadlines ? <div style={{color:"red", fontSize: "12px"}}>Puoi selezionare solo una scadenza</div>: null}
      <div className="dbx-reconciliation-modal-addExtistingDeadlines-filter">
        {!filterDone &&
      <FilterDeadlines startDateFilter={startDateFilter}
        setStartDateFilter={setStartDateFilter}
        endDateFilter={endDateFilter}
        setEndDateFilter={setEndDateFilter}
        selectedCounterparts={selectedCounterparts}
        setSelectedCounterparts={setSelectedCounterparts}
        deadlinesCounterparts={deadlinesCounterpartsArrObj}
        dateError={dateError}
        inModal={true}>
      </FilterDeadlines>}
      </div>
      <div className="dbx-reconciliation-modal-addExtistingDeadlines-deadlines">
        {filterDone ? renderDeadlines() : null}
      </div>
    </div>
  );
};

export default AddExistingDeadline;
